import React from 'react'

import { ForAccountType } from '../components/Auth/ForAccountType'
import { ListTemplates } from '../components/Templates/ListTemplates'
import { AccountTypePermissions } from '../domain/account-type.domain'

import { Page } from './shared/Page'

export const ManageTemplatesPage: React.FC = () => {
    return (
        <ForAccountType permission={AccountTypePermissions.TemplateList}>
            <Page>
                <ListTemplates />
            </Page>
        </ForAccountType>
    )
}
